import React, { useState } from 'react';
import { Row, Col, Card, Skeleton, Tooltip, Button, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

import {
  returnStatusConsultaLabel,
  returnStatusConsultaColor,
} from '../../../utils';
import { putSolicitarRetornoTransSat } from '../../../../../services';

import { Texto } from '../Texto';

import * as S from '../styles';

export function CardConsulta({ data, loading = false }) {
  const [loadingSolicitacao, setLoadingSolicitacao] = useState(false);

  const podeSolicitarRetorno =
    data?.idConsulta === 27 && [1, 9].includes(data?.idStatus);

  const solicitarRetornoTransSat = async () => {
    setLoadingSolicitacao(true);

    const response = await putSolicitarRetornoTransSat(data?.id);

    if (response?.status >= 200 && response?.status < 300) {
      message.success('Retorno da TransSat solicitado com sucesso!');
    } else {
      message.error(
        response?.error?.response?.data?.detail ||
          'Erro ao solicitar retorno da TransSat.'
      );
    }

    setLoadingSolicitacao(false);
  };

  return (
    <Col span={11}>
      <Card
        bordered={false}
        style={{
          borderRadius: 16,
          padding: 0,
          background: '#F1F4F5',
          height: '100%',
        }}
      >
        <Row gutter={[40, 24]}>
          <Col
            xs={{ span: 12, offset: 1 }}
            md={{ span: 24, offset: 1 }}
            flex="1"
          >
            <Row>
              <Skeleton
                active
                size="small"
                loading={loading}
                paragraph={{ rows: 0 }}
              >
                <S.ModalTitle>{data?.nomeConsulta || ''}</S.ModalTitle>
                {podeSolicitarRetorno && (
                  <Tooltip title="Solicitar retorno da TransSat">
                    <Button
                      type="text"
                      shape="circle"
                      aria-label="Solicitar retorno da TransSat"
                      icon={<ReloadOutlined />}
                      loading={loadingSolicitacao}
                      onClick={solicitarRetornoTransSat}
                    />
                  </Tooltip>
                )}
              </Skeleton>
            </Row>
          </Col>
          <Col
            xs={{ span: 12, offset: 1 }}
            md={{ span: 24, offset: 1 }}
            flex="1"
          >
            <Row>
              <Skeleton
                active
                size="small"
                loading={loading}
                paragraph={{ rows: 0 }}
              >
                {data?.idStatus && (
                  <S.ButtonTypeHeader
                    color={returnStatusConsultaColor(data?.idStatus)}
                  >
                    {returnStatusConsultaLabel(data?.idStatus)}
                  </S.ButtonTypeHeader>
                )}
              </Skeleton>
            </Row>
          </Col>
        </Row>
        <Row style={{ marginBottom: 6, marginTop: 8 }}>
          <Skeleton
            active
            size="small"
            loading={loading}
            paragraph={{ rows: 0 }}
          >
            <Texto valor={data?.tipoDivergencia || ''} />
            {data?.idStatus === 3 && <Texto valor="Timeout" />}
            {data?.idStatus === 5 && <Texto valor="Timeout" />}
          </Skeleton>
        </Row>
        <Row>
          <Skeleton
            active
            size="small"
            loading={loading}
            paragraph={{ rows: 0 }}
          >
            <S.TextoCardConsultaOrientacao
              color={data?.idStatus === 6 && '#D42929'}
            >
              {data?.criticaConsulta || '-'}
            </S.TextoCardConsultaOrientacao>
          </Skeleton>
        </Row>
        <Row style={{ margin: '30px 0 28px 0' }}>
          {data?.itensValidacaoConsulta?.map((item, index) => (
            <Col span={11} key={index} style={{ margin: '12px 0' }}>
              <Row>
                <Skeleton
                  active
                  size="small"
                  loading={loading}
                  paragraph={{ rows: 2 }}
                >
                  <Texto
                    title
                    valor={`${item?.nome || ''}:`}
                    color="#0D3549"
                  />
                  <Texto valor={item?.valor || ''} />
                </Skeleton>
              </Row>
            </Col>
          ))}
        </Row>
      </Card>
    </Col>
  );
}
